


import React from 'react'
import './Footer.css'
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap'
import { Link } from 'react-router-dom'


const MY_ACCOUNT = [
  {
    display: 'Author Profile',
    url: '/seller-profile'

  },

  {
    display: 'Create Item',
    url: '/create'

  },

  {
    display: 'Collection',
    url: '/market'

  },

  {
    display: 'Edit Profile',
    url: '/edit-profile'

  },
]

const RESOURCES = [
  {
    display: 'Help Center',
    url: '#'

  },

  {
    display: 'Partner',
    url: '#'

  },

  {
    display: 'Community',
    url: '#'

  },

  {
    display: 'Activity',
    url: '#'

  },
]

const COMPANY = [
  {
    display: 'About',
    url: '#'

  },

  {
    display: 'Ranking',
    url: '#'

  },

  {
    display: 'Career',
    url: '#'

  },

  {
    display: 'Contact Us',
    url: '/contact'

  },
]


const Footer = () => {
  return (
    <footer className='footer'>
    <Container>
      <Row>
        <Col lg='3' md='6' sm='6'  className='mb-4'>
        <div className='logo'>
        <h2 className='d-flex gap-2 align-tems-center'>
        <spam><i class="ri-fire-fill"></i>
        </spam> 
       ZAK NFTs
        </h2>
        <p> Es un hecho establecido hace demasiado tiempo que un lector se distraerá con el
        contenido del texto de un sitio mientras que mira su diseño. </p>
    </div>
        </Col>

        <Col lg='2' md='3' sm='6' className='mb-4'>
          <h5> My Account</h5>
          <ListGroup>
            {
              MY_ACCOUNT.map((item, index) =>
              <ListGroupItem  key={index} className='list_item'>
                <Link to={item.url}>{item.display} </Link>
              </ListGroupItem>
              )
            }
          </ListGroup>
        </Col>

        <Col lg='2' md='3' sm='6'  className='mb-4'>
        <h5> Resources</h5>
          <ListGroup>
            {
              RESOURCES.map((item, index) =>
              <ListGroupItem  key={index} className='list_item'>
                <Link to={item.url}>{item.display} </Link>
              </ListGroupItem>
              )
            }
          </ListGroup>
        </Col>

        <Col lg='2' md='3' sm='6'  className='mb-4'>
        <h5> Company</h5>
          <ListGroup>
            {
              COMPANY.map((item, index) =>
              <ListGroupItem  key={index} className='list_item'>
                <Link to={item.url}>{item.display} </Link>
              </ListGroupItem>
              )
            }
          </ListGroup>
        </Col>

        <Col lg='3' md='6' sm='6' className='mb-4'>
          <h5> Newsletter</h5> 
          <input type='text' className='newsletter' placeholder='Email'/>
          <div className='social_links d-flex gap-3 align-items-center'>
          <span><Link to='#'> <i class="ri-facebook-line"></i></Link></span>
          <span><Link to='#'> <i class="ri-instagram-line"></i></Link></span>
          <span><Link to='#'> <i class="ri-twitter-line"></i> </Link></span>
          <span><Link to='#'> <i class="ri-linkedin-line"></i> </Link></span>
          <span><Link to='#'> <i class="ri-discord-line"></i></Link></span>
          </div>
        </Col>
        <Col lg='12' className='mt=4 text-center'>
        <p className='copyright'> Copyrights 2022, Developed by Zakir Hossain, Founder: Zack Consulting. All Rights 
        are Reserved.</p>

        </Col>
      </Row>
    </Container>

    </footer>
  )
}

export default Footer